var cms_base_url="https://cms.coveritup.in/"
// start frmTracking
 $("#frmTracking").on("submit", function(r) {
var form_id="frmTracking";
 r.preventDefault();
       
 // js validation  end 
   
  var data_array = {
	email:jQuery("#"+form_id+" #email").val(),
    order_number:jQuery("#"+form_id+" #order_number").val()
    
 };
  
  var submit_btn_text=jQuery("#submit-btn-"+form_id).html(); 
       // ajax
             jQuery.ajax({ 
             url:cms_base_url+'api/form/tracking',
             type: 'POST',
                "async": true,
 				 "crossDomain": true,
            data: JSON.stringify(data_array),
             beforeSend: function(){              

              jQuery("#submit-btn-"+form_id).prop("disabled", true);; 
              jQuery("#submit-btn-"+form_id).html('Please wait...'); 
              //jQuery("#load-img-"+form_id).show(); 
            },
             success: function (response) {         
                                //jsonObj = JSON.parse(response);
               					if(response.status_code==1){
                                   jQuery(".message-box-" + form_id).removeClass("error");
                                 jQuery(".message-box-" + form_id).addClass("success");

								 //showMessage(response.message,"green");
                                  //$("#" + form_id).trigger("reset");
                                 } else{
                                 jQuery(".message-box-" + form_id).removeClass("success");
                                 jQuery(".message-box-" + form_id).addClass("error");    
                                    //alert(response.message);
                                  //$("#" + form_id).trigger("reset");
                                         
                                } 
               
            				   jQuery(".message-box-" + form_id).html(response.message);
                                  jQuery(".message-box-" + form_id).show(); 
               
             },
              error: function(e) {
                 //jsonObj = JSON.parse(response);
				 alert("Please try after some time");
                        
                    },
               complete: function() {
                jQuery("#submit-btn-"+form_id).removeAttr("disabled"),jQuery("#submit-btn-"+form_id).html(submit_btn_text); 
            }
                 
           });
            
   			
            return false;
   
    })